import { Reveal } from './Reveal';

const CHAPTERS = [
  {
    n: '01',
    title: 'Agilidade sem filas',
    text: 'Nada de madrugar em fila de DETRAN ou se perder em sistema. Eu cuido do trâmite inteiro — presencial e digital — e você acompanha tudo pelo WhatsApp.',
  },
  {
    n: '02',
    title: 'Transparência total',
    text: 'Você sabe exatamente o que está sendo feito, quanto custa e qual o prazo. Cada etapa é informada, com protocolo e comprovante na mão.',
  },
  {
    n: '03',
    title: 'Cobertura em toda MG',
    text: 'Base em Betim, Contagem e Belo Horizonte, com atendimento em toda Minas Gerais. Onde seu veículo estiver, eu resolvo.',
  },
];

export const Manifesto = () => (
  <section
    id="diferenciais"
    data-testid="manifesto-section"
    className="py-24 sm:py-32 bg-white"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="text-xs font-mono uppercase tracking-[0.25em] text-blue-600 mb-4">
          03 — Por que o Davy
        </p>
        <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-900 max-w-2xl leading-tight">
          Despachante de verdade resolve.{' '}
          <span className="text-stroke-blue">Não enrola.</span>
        </h2>
      </Reveal>

      <div className="mt-16 space-y-0">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.1}>
            <div
              data-testid={`manifesto-chapter-${c.n}`}
              className="group grid sm:grid-cols-[120px_1fr] gap-4 sm:gap-10 py-10 sm:py-12 border-t border-slate-200 last:border-b"
            >
              <span className="font-display text-5xl sm:text-6xl font-extrabold text-slate-200 group-hover:text-blue-500/50 transition-colors duration-500">
                {c.n}
              </span>
              <div>
                <h3 className="font-display font-bold text-xl sm:text-2xl text-slate-900">
                  {c.title}
                </h3>
                <p className="mt-3 max-w-2xl text-slate-500 text-sm sm:text-base leading-relaxed">
                  {c.text}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
